<app-organization-sidebar-layout>
  <app-page-header>
    <app-page-title> {{ 'cockpit.analysis.title' | transloco }} </app-page-title>
  </app-page-header>

  <div class="@container/main flex flex-col gap-5">
    <!-- KPI section -->
    <section class="grid grid-cols-1 @2xl/main:grid-cols-2 gap-5">
      <!-- consumption card -->
      <app-analysis-consumption-kpi-card />
      <!-- hpfc card -->
      <app-analysis-dashboard-hpfc-kpi-card [organizationId]="organizationID()" />
    </section>
    <!-- LMA section -->
    <section class="flex flex-col gap-5">
      <div class="flex items-center">
        <h2 class="flex-1 text-2xl font-medium leading-8 line-clamp-1">
          {{ 'cockpit.analysis.lma.title' | transloco }}
        </h2>
        <ui-button
          class="flex-none"
          mode="outlined"
          notImplemented
          [notImplementedTitle]="'cockpit.analysis.lma.contactDialog.title' | transloco"
          [notImplementedMessage]="'cockpit.analysis.lma.contactDialog.message' | transloco"
          data-track="analysis-dashboard-add-lma-button"
        >
          <ng-icon name="heroSquaresPlus" size="20" slot="start" class="!block" />
          {{ 'cockpit.analysis.lma.requestAnalysis' | transloco }}
        </ui-button>
      </div>

      @if (organizationID(); as oID) {
        <app-document-lma-card-list
          [organizationID]="oID"
          (clickOpen)="onClickPreviewLma($event)"
        />
      }
    </section>
  </div>
</app-organization-sidebar-layout>

<ng-container *appFeatureEnabled="'analysisTutorial'">
  <app-tutorial-analysis-popover />
</ng-container>
